// frontend/src/pages/Archive.js
// Historical listing archive — ended/sold listings with one-click relist

import React, { useState, useEffect } from 'react';
import { api } from '../App';

const CHANNEL_LABELS = { ebay_source:'Euphoric Operations', ebay_store2:'TNT Operations', ebay_store3:'Firestarters', walmart:'Walmart', amazon:'Amazon', mercari:'Mercari', poshmark:'Poshmark' };
const CHANNEL_ICONS  = { ebay_source:'🛒', ebay_store2:'🏪', walmart:'🟡', amazon:'📦', mercari:'🔵', poshmark:'🔴' };
const STATUS_BADGE   = { active:'badge-active', ended:'badge-ended', sold:'badge-shipped', error:'badge-error', pending:'badge-pending' };

function ChannelPills({ listings }) {
  return (
    <div style={{ display:'flex', flexWrap:'wrap', gap:4, marginTop:6 }}>
      {listings.map(l => (
        <span key={l.channel} style={{ display:'inline-flex', alignItems:'center', gap:3, padding:'2px 7px', borderRadius:99, fontSize:11, fontWeight:600, background:'rgba(255,255,255,.05)', border:'1px solid var(--border)' }}>
          {CHANNEL_ICONS[l.channel]}
          <span style={{ color:'var(--muted)' }}>{CHANNEL_LABELS[l.channel]}</span>
          <span className={`badge ${STATUS_BADGE[l.status] || ''}`} style={{ padding:'1px 5px', fontSize:10 }}>{l.status}</span>
        </span>
      ))}
    </div>
  );
}

export default function Archive() {
  const [products, setProducts]   = useState([]);
  const [total, setTotal]         = useState(0);
  const [search, setSearch]       = useState('');
  const [page, setPage]           = useState(1);
  const [relisting, setRelisting] = useState({});
  const [feedback, setFeedback]   = useState({});
  const [selected, setSelected]   = useState({});
  const [bulkWorking, setBulkWorking] = useState(false);
  const [bulkResult, setBulkResult]   = useState(null);
  const LIMIT = 30;

  function load(p = 1, s = search) {
    const params = new URLSearchParams({ page: p, limit: LIMIT });
    if (s) params.set('search', s);
    api.get(`/archive?${params}`).then(r => {
      setProducts(r.data.products);
      setTotal(r.data.total);
    });
  }

  useEffect(() => { load(); }, []);

  function handleSearch(e) {
    e.preventDefault();
    setPage(1);
    load(1, search);
  }

  async function relist(sku) {
    setRelisting(prev => ({ ...prev, [sku]: true }));
    setFeedback(prev => ({ ...prev, [sku]: '' }));
    try {
      await api.post(`/archive/${encodeURIComponent(sku)}/relist`);
      setFeedback(prev => ({ ...prev, [sku]: 'success' }));
      // Refresh after a moment so the relisted item moves out of archive
      setTimeout(() => load(page, search), 1500);
    } catch (err) {
      setFeedback(prev => ({ ...prev, [sku]: err.response?.data?.error || 'Relist failed' }));
    } finally {
      setRelisting(prev => ({ ...prev, [sku]: false }));
    }
  }

  function toggleSelect(sku) { setSelected(prev => ({ ...prev, [sku]: !prev[sku] })); }
  function toggleAll() {
    const allSelected = products.every(p => selected[p.sku]);
    const next = {}; products.forEach(p => { next[p.sku] = !allSelected; });
    setSelected(next);
  }
  async function bulkRelist() {
    const skus = Object.entries(selected).filter(([,v]) => v).map(([k]) => k);
    if (!skus.length) return;
    setBulkWorking(true); setBulkResult(null);
    const r = await api.post('/archive/relist-bulk', { skus }).catch(e => e.response);
    setBulkResult(r?.data);
    setBulkWorking(false); setSelected({});
    load(page, search);
  }
  const selectedCount = Object.values(selected).filter(Boolean).length;

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">🗃️ Listing Archive</div>
          <div style={{ fontSize:12, color:'var(--muted)', marginTop:2 }}>
            Ended &amp; closed listings — relist any time
          </div>
        </div>
        <div style={{ display:'flex', gap:8, alignItems:'center' }}>
          {selectedCount > 0 && (
            <button className="btn btn-primary" onClick={bulkRelist} disabled={bulkWorking}>
              {bulkWorking ? '⏳ Relisting…' : `🔁 Relist Selected (${selectedCount})`}
            </button>
          )}
          <button className="btn btn-ghost" style={{ fontSize:12 }} onClick={toggleAll}>
            {products.every(p => selected[p.sku]) ? 'Deselect All' : 'Select All'}
          </button>
          <span style={{ fontSize:13, color:'var(--muted)' }}>{total} archived</span>
        </div>
      </div>

      {bulkResult && (
        <div className="card" style={{ marginBottom:12, borderColor: bulkResult.failed?.length ? 'var(--danger)' : 'var(--accent2)', padding:'10px 14px' }}>
          <span className="success-text">✓ {bulkResult.success?.length} relisted</span>
          {bulkResult.failed?.length > 0 && <span className="error-text" style={{ marginLeft:12 }}>✗ {bulkResult.failed.length} failed</span>}
        </div>
      )}
      <form onSubmit={handleSearch} style={{ display:'flex', gap:8, marginBottom:16 }}>
        <input
          value={search}
          onChange={e => setSearch(e.target.value)}
          placeholder="Search SKU, title, UPC…"
          style={{ maxWidth:320 }}
        />
        <button type="submit" className="btn btn-primary">Search</button>
        {search && <button type="button" className="btn btn-ghost" onClick={() => { setSearch(''); load(1, ''); }}>Clear</button>}
      </form>

      {products.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">🗃️</div>
          <div>No archived listings found</div>
        </div>
      ) : (
        <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
          {products.map(p => {
            const img    = JSON.parse(p.images || '[]')[0];
            const relisted = feedback[p.sku] === 'success';

            function toggleSelect(sku) { setSelected(prev => ({ ...prev, [sku]: !prev[sku] })); }
  function toggleAll() {
    const allSelected = products.every(p => selected[p.sku]);
    const next = {}; products.forEach(p => { next[p.sku] = !allSelected; });
    setSelected(next);
  }
  async function bulkRelist() {
    const skus = Object.entries(selected).filter(([,v]) => v).map(([k]) => k);
    if (!skus.length) return;
    setBulkWorking(true); setBulkResult(null);
    const r = await api.post('/archive/relist-bulk', { skus }).catch(e => e.response);
    setBulkResult(r?.data);
    setBulkWorking(false); setSelected({});
    load(page, search);
  }
  const selectedCount = Object.values(selected).filter(Boolean).length;

  return (
              <div key={p.sku} className="card" style={{ display:'flex', gap:14, alignItems:'flex-start', opacity: relisted ? .5 : 1, transition:'opacity .3s' }}>

                {/* Select checkbox */}
                <div style={{ paddingTop:4, flexShrink:0 }}>
                  <input type="checkbox" checked={!!selected[p.sku]} onChange={() => toggleSelect(p.sku)}
                    style={{ width:'auto', accentColor:'var(--accent)', width:18, height:18, cursor:'pointer' }} />
                </div>

                {/* Thumbnail */}
                {img ? (
                  <img src={img} alt="" style={{ width:64, height:64, objectFit:'cover', borderRadius:8, flexShrink:0, border:'1px solid var(--border)' }} />
                ) : (
                  <div style={{ width:64, height:64, borderRadius:8, background:'var(--border)', flexShrink:0, display:'flex', alignItems:'center', justifyContent:'center', fontSize:24 }}>📦</div>
                )}

                {/* Info */}
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:8 }}>
                    <div>
                      <div style={{ fontWeight:600, fontSize:14, marginBottom:2 }}>{p.title}</div>
                      <div style={{ display:'flex', gap:10, fontSize:12, color:'var(--muted)' }}>
                        <span className="mono">{p.sku}</span>
                        {p.sku_upc  && <span>UPC: {p.sku_upc}</span>}
                        {p.sku_year && <span>Listed: {p.sku_year}</span>}
                        {p.location && <span>📦 {p.location}</span>}
                        {p.condition && <span>{p.condition}</span>}
                      </div>
                    </div>

                    {/* Relist button */}
                    <div style={{ flexShrink:0, textAlign:'right' }}>
                      {relisted ? (
                        <span className="success-text" style={{ fontSize:13 }}>✓ Relisted</span>
                      ) : (
                        <button
                          className="btn btn-primary"
                          style={{ fontSize:12, padding:'6px 14px' }}
                          onClick={() => relist(p.sku)}
                          disabled={relisting[p.sku]}
                        >
                          {relisting[p.sku] ? '⏳ Relisting…' : '🔁 Relist'}
                        </button>
                      )}
                      {feedback[p.sku] && feedback[p.sku] !== 'success' && (
                        <div className="error-text" style={{ fontSize:11, marginTop:4 }}>{feedback[p.sku]}</div>
                      )}
                    </div>
                  </div>

                  {/* Channel status pills */}
                  <ChannelPills listings={p.channel_listings || []} />
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Pagination */}
      {total > LIMIT && (
        <div style={{ display:'flex', gap:8, justifyContent:'center', marginTop:20 }}>
          <button className="btn btn-ghost" disabled={page === 1} onClick={() => { setPage(p => p-1); load(page-1); }}>← Prev</button>
          <span style={{ padding:'8px 12px', color:'var(--muted)', fontSize:13 }}>{page} / {Math.ceil(total/LIMIT)}</span>
          <button className="btn btn-ghost" disabled={page >= Math.ceil(total/LIMIT)} onClick={() => { setPage(p => p+1); load(page+1); }}>Next →</button>
        </div>
      )}
    </div>
  );
}
